import React from 'react';
import { compose } from 'recompose';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import Modal from '../../Common/Modal';
import config from '../../../config';
import AddReminderForm from './AddReminderForm';
import ReminderModal from './ReminderModal';

class AddReminderModal extends ReminderModal {
  getAjaxObject(params) {
    return {
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      url: `${config.localeApi}/reminders`,
      data: JSON.stringify(params)
    };
  }

  handleSuccess() {
    toastr.success(
      this.props.t('account.dashboard_remind_me_added_successfully', 'Reminder added successfully'),
    );
  }

  render() {
    return <div className="d-flex add-remind-me-btn">
      {<Modal size="md" modalId="addReminderModal"
        open={this.state.openModal}
        onClose={() => this.setOpenModal(false)}
      >
        {this.state.openModal && <AddReminderForm 
          reminderTypes={this.props.reminderTypes}
          submitNewData={this.submitNewData}
          modalIdToDismiss="addReminderModal"
        />
        }
      </Modal>}
      <button
        type='button'
        onClick={() => this.setOpenModal(true)}
        className='btn btn-primary'
      >
        <HTMLTrans id='account.dashboard_add_new_reminder'>Add New Reminder</HTMLTrans>
      </button>
    </div>
  }
}

const enhance = compose(withTranslationProvider);
export default enhance(AddReminderModal);
export const undecorated = AddReminderModal;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/AddReminderModal.js